export const USER_SOURCE = 'source';
export const AUTH_TOKEN_PARAM_NAME = 'auth_token';
